export const mockProducts = [
  // Electronics
  {
    id: 1,
    name: "Gaming Laptop",
    category: "Electronics",
    price: 1299.99,
    stock: 25,
    sales: 156,
    image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 2,
    name: "Wireless Gaming Mouse",
    category: "Electronics",
    price: 79.99,
    stock: 45,
    sales: 234,
    image: "https://images.unsplash.com/photo-1613141411244-0e4ac259d217?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 3,
    name: "4K Smart TV",
    category: "Electronics",
    price: 899.99,
    stock: 0,
    sales: 89,
    image: "https://images.unsplash.com/photo-1593784991095-a205069470b6?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 16,
    name: "Wireless Earbuds",
    category: "Electronics",
    price: 159.99,
    stock: 8, // Low stock
    sales: 567,
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 17,
    name: "Smart Watch",
    category: "Electronics", 
    price: 299.99,
    stock: 42,
    sales: 328,
    image: "https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 18,
    name: "Bluetooth Speaker",
    category: "Electronics",
    price: 89.99,
    stock: 0, // Out of stock
    sales: 245,
    image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=500&auto=format&fit=crop&q=60"
  },

  // Fashion
  {
    id: 4,
    name: "Designer Dress",
    category: "Fashion",
    price: 149.99,
    stock: 8,
    sales: 167,
    image: "https://images.unsplash.com/photo-1539008835657-9e8e9680c956?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 5,
    name: "Leather Handbag",
    category: "Fashion",
    price: 299.99,
    stock: 12,
    sales: 145,
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 6,
    name: "Winter Jacket",
    category: "Fashion",
    price: 199.99,
    stock: 5,
    sales: 89,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 19,
    name: "Summer Dress",
    category: "Fashion",
    price: 79.99,
    stock: 15,
    sales: 189,
    image: "https://images.unsplash.com/photo-1585487000160-6ebcfceb0d03?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 20,
    name: "Men's Sneakers",
    category: "Fashion",
    price: 129.99,
    stock: 4, // Low stock
    sales: 278,
    image: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=500&auto=format&fit=crop&q=60"
  },

  // Home & Living
  {
    id: 7,
    name: "Modern Sofa Set",
    category: "Home & Living",
    price: 1299.99,
    stock: 3,
    sales: 45,
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 8,
    name: "Coffee Table",
    category: "Home & Living",
    price: 249.99,
    stock: 15,
    sales: 123,
    image: "https://images.unsplash.com/photo-1619911013257-8f1fbc919fc9?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 9,
    name: "Bed Frame",
    category: "Home & Living",
    price: 599.99,
    stock: 0,
    sales: 67,
    image: "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 21,
    name: "Table Lamp",
    category: "Home & Living",
    price: 69.99,
    stock: 23,
    sales: 156,
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 22,
    name: "Kitchen Blender",
    category: "Home & Living",
    price: 199.99,
    stock: 0, // Out of stock
    sales: 134,
    image: "https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=500&auto=format&fit=crop&q=60"
  },

  // Sports
  {
    id: 10,
    name: "Running Shoes",
    category: "Sports",
    price: 129.99,
    stock: 35,
    sales: 289,
    image: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 11,
    name: "Yoga Mat",
    category: "Sports",
    price: 39.99,
    stock: 50,
    sales: 445,
    image: "https://images.unsplash.com/photo-1603988363607-e1e4a66962c6?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 12,
    name: "Tennis Racket Pro",
    category: "Sports",
    price: 189.99,
    stock: 7,
    sales: 156,
    image: "https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 23,
    name: "Fitness Dumbbell Set",
    category: "Sports",
    price: 149.99,
    stock: 7, // Low stock
    sales: 198,
    image: "https://images.unsplash.com/photo-1586401100295-7a8096fd231a?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 24,
    name: "Basketball",
    category: "Sports",
    price: 29.99,
    stock: 32,
    sales: 445,
    image: "https://images.unsplash.com/photo-1494199505258-5f95387f933c?w=500&auto=format&fit=crop&q=60"
  },

  // Books
  {
    id: 13,
    name: "Programming Guide",
    category: "Books",
    price: 49.99,
    stock: 25,
    sales: 234,
    image: "https://images.unsplash.com/photo-1517842645767-c639042777db?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 14,
    name: "Business Strategy",
    category: "Books",
    price: 34.99,
    stock: 0,
    sales: 167,
    image: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 15,
    name: "Novel Collection",
    category: "Books",
    price: 99.99,
    stock: 4,
    sales: 89,
    image: "https://images.unsplash.com/photo-1531988042231-d39a9cc12a9a?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 25,
    name: "Science Fiction Collection",
    category: "Books",
    price: 45.99,
    stock: 5, // Low stock
    sales: 167,
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=500&auto=format&fit=crop&q=60"
  },
  {
    id: 26,
    name: "Cooking Guide",
    category: "Books",
    price: 39.99,
    stock: 0, // Out of stock
    sales: 223,
    image: "https://images.unsplash.com/photo-1589998059171-988d887df646?w=500&auto=format&fit=crop&q=60"
  }
];